import { useState, useMemo } from "react";
import { ICompany } from "@/types";
import CompanyCard from "@/components/Card/company-card";

interface CompanyListProps {
  onSelectCompany: React.Dispatch<React.SetStateAction<string | null>>;
  selectedCompany: string | null;
  companiesList: ICompany[];
}

interface Company {
  id: string;
  name: string;
  logo?: string;
}

const transformCompanies = (apiData: ICompany[]): Company[] => {
  return apiData?.map(company => ({
    id: String(company.id),
    name: company.name ?? "Unknown",
    logo: company.large_logo_url,
  }));
};

export default function CompanyList({
  onSelectCompany,
  selectedCompany,
  companiesList,
}: CompanyListProps) {
  const [searchQuery, setSearchQuery] = useState("");

  const MOCK_COMPANIES = useMemo(
    () => transformCompanies(companiesList),
    [companiesList]
  );

  const filteredCompanies = useMemo(() => {
    return MOCK_COMPANIES?.filter(company =>
      company?.name?.toLowerCase().includes(searchQuery?.toLowerCase())
    );
  }, [searchQuery, MOCK_COMPANIES]);
  return (
    <div className="space-y-5 ">
      <div className="relative">
        <input
          type="text"
          placeholder="Search companies..."
          value={searchQuery}
          onChange={e => setSearchQuery(e.target.value)}
          className="w-full pl-10 pr-4 py-2.5 rounded-lg border border-border bg-background text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-1 focus:ring-primary focus:border-primary transition-colors"
        />
      </div>

      <div className=" rounded-lg overflow-hidden">
        <div className="max-h-[500px] overflow-y-auto custom-scrollbar">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-2 ">
            {filteredCompanies?.length > 0 ? (
              filteredCompanies?.map(company => (
                <CompanyCard
                  key={company?.id}
                  company={company}
                  isSelected={selectedCompany == company.id}
                  onSelect={onSelectCompany}
                />
              ))
            ) : (
              <div className="col-span-full py-12 text-center">
                <p className="text-muted-foreground">
                  No companies found matching "{searchQuery}"
                </p>
              </div>
            )}
          </div>
        </div>
      </div>

      <div className="text-xs text-muted-foreground text-center">
        {filteredCompanies?.length} of {MOCK_COMPANIES?.length} companies
      </div>
    </div>
  );
}
